var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIncome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 4,
    fill: "#D7F3E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40002259_102461)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4 3.15538C10.9473 3.06298 10.4807 3.01631 10 3.01538C6.1339 3.01538 3 6.14578 3 10.0077C3 13.8696 6.1339 17 10 17C13.8661 17 17 13.8696 17 10.0077C16.9991 9.52841 16.9524 9.06221 16.86 8.60908",
    stroke: "#20BB71",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99961 7.90981C9.22611 7.90981 8.59961 8.37951 8.59961 8.95911C8.59961 9.53801 9.22611 10.0077 9.99961 10.0077C10.7731 10.0077 11.3996 10.4767 11.3996 11.0563C11.3996 11.6359 10.7731 12.1056 9.99961 12.1056M9.99961 7.90981C10.6086 7.90981 11.128 8.20171 11.3198 8.60981M9.99961 7.90981V7.21051M9.99961 12.1056C9.39061 12.1056 8.87121 11.8137 8.67941 11.4056M9.99961 12.1056V12.8049",
    stroke: "#20BB71",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9973 3L14.0748 5.9218M13.498 3.3647L13.5806 5.5263C13.5806 6.0359 13.8851 6.3537 14.4402 6.3936L16.627 6.4965",
    stroke: "#20BB71",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40002259_102461"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncome);
export default __webpack_public_path__ + "static/media/icon-income.885d2db464598b33f6810db946ad21d8.svg";
export { ForwardRef as ReactComponent };